import atlas from 'azure-maps-control';
import { PolylineProps, PushpinProps } from '../../../types/MapModels';

export function convertPushpinsToAzure(pushpins: PushpinProps[] = []): atlas.data.Feature<atlas.data.Point, any>[] {
    return pushpins.map((p) => {
        const [lat, lon] = p.location;
        const coordinates: [number, number] = [lon, lat];
        return new atlas.data.Feature(
            new atlas.data.Point(coordinates),
            {
                ...p.options,
                ...p.eventHandlers,
            },
        );
    });
}

export function convertPolylines(
    polylines: PolylineProps[] = [],
): atlas.data.Feature<atlas.data.LineString, any>[] {
    return polylines.map((polyline) => {
        const azureCoords = polyline.locations.map(([lat, lon]) => [lon, lat]) as [number, number][];
        const line = new atlas.data.LineString(azureCoords);
        const properties = {
            strokeColor: polyline.options?.strokeColor,
            strokeWidth: polyline.options?.strokeThickness,
            ...((polyline as any)?.options?.metadata ?? {}),
            ...(polyline.metadata ?? {}),
        };
        return new atlas.data.Feature(line, properties);
    });
}

export type MapBounds = {
    north: number;
    south: number;
    east: number;
    west: number;
};

export const DEFAULT_CAMERA_PADDING = {
    top: 60,
    bottom: 60,
    left: 60,
    right: 60,
} as const;
